import React from "react";
import { forwardRef } from "react";

const MFCapitalGainReportTable = forwardRef(
  (
    {
      tableData,
      handleTableScroll,
      hasVerticalScroll,
      scrollLoaderTable,
      loader,
      LoaderForSearch,
      clientDashboard,
    },
    ref
  ) => {
    return (
      <table className="table" style={{ width: "300%" }}>
        <thead>
          <tr>
            <th className={clientDashboard ? "text-center" : ""}>
              <span className="wrap-th">
                <span>Sr No.</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>Segment Type</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>ISIN</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>Scheme Name</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>Units</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>Purchase Date</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>Purchase NAV</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>Purchase Amount</span>
              </span>
            </th>
            {/* <th>
              <span className="wrap-th">
                <span>Category</span>
              </span>
            </th> */}
            <th>
              <span className="wrap-th">
                <span>Sell Date</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>Sell NAV</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>Sell Amount</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>Jan18 NAV</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>Jan18 NAV Purchase Amount</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>STT</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>TDS</span>
              </span>
            </th>
            {hasVerticalScroll && <th className="scrollerthead"></th>}
          </tr>
        </thead>
        <tbody
          onScroll={(e) => handleTableScroll(e)}
          id="per-table-body"
          ref={ref}
        >
          {tableData?.length > 0 &&
            tableData.map((item, index) => {
              return (
                <tr key={index}>
                  <td className={clientDashboard ? "text-center" : ""}>
                    {index + 1}
                  </td>
                  <td>{item?.segmentType}</td>
                  <td>{item?.isin || "-"}</td>
                  <td>{item?.schName || "-"}</td>
                  <td>{item?.units || "-"}</td>
                  <td>{item?.purchDt || "-"}</td>
                  <td>{item?.purchNav || "-"}</td>
                  <td>{item?.purchAmt || "-"}</td>
                  {/* <td>Low Duration Fund</td> */}
                  <td>{item?.sellDt || "-"}</td>
                  <td>{item?.sellNav || "-"}</td>
                  <td>{item?.sellAmt || "-"}</td>
                  <td>{item?.jan18Nav || "-"}</td>
                  <td>{item?.jan18PurchAmt || "-"}</td>
                  <td>{item?.stt || "-"}</td>
                  <td>{item?.tds || "-"}</td>
                </tr>
              );
            })}
          {scrollLoaderTable && !loader && (
            <div className="loader-center">
              <LoaderForSearch />
            </div>
          )}
        </tbody>
      </table>
    );
  }
);

export default MFCapitalGainReportTable;
